import React from "react";
import { FiDownload } from "react-icons/fi";
import PayoutButton from "./PayoutButton";
import { cx } from "./payoutDesignSystem";

type PayoutFilterActionsProps = {
  onClear: () => void;
  onExport?: () => void;
  exportLabel?: string;
  clearLabel?: string;
  className?: string;
};

function PayoutFilterActions({
  onClear,
  onExport,
  exportLabel = "Export",
  clearLabel = "Clear All",
  className = "",
}: PayoutFilterActionsProps) {
  return (
    <div className={cx("flex min-w-0 flex-wrap items-end gap-3", className)}>
      {onExport && (
        <PayoutButton
          onClick={onExport}
          icon={<FiDownload className="text-lg text-[#505E8E]" />}
          className="payout-filter-button min-w-[118px]"
        >
          {exportLabel}
        </PayoutButton>
      )}
      <PayoutButton
        variant="subtle"
        onClick={onClear}
        className="payout-filter-button min-w-[104px]"
      >
        {clearLabel}
      </PayoutButton>
    </div>
  );
}

export default PayoutFilterActions;
